import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42n2NQQqAIBQFvf/hIgiRsLa1sl/RD0Jlsk0uggbmrQae4Z9knr1UCdNMkBUpbsUUYw32RbCdxfkR13uGpuU8tAYfcn4vbiCpfE39oDS3AAAAAElFTkSuQmCC"};
